import { fetchAndActivate, getRemoteConfig, getString } from 'firebase/remote-config';
import { create } from 'zustand';
import { secondaryApp } from 'config/firebase';

interface DateTimeRangeState {
  config: Record<string, string> | null;
  isLoaded: boolean;
  loadConfig: () => Promise<void>;
}

export const useDateTimeRangeStore = create<DateTimeRangeState>((set) => ({
  config: null,
  isLoaded: false,
  loadConfig: async () => {
    try {
      const remoteConfig = getRemoteConfig(secondaryApp);
      await fetchAndActivate(remoteConfig);
      const rawConfig = getString(remoteConfig, 'date_time_range');
      const parsed = JSON.parse(rawConfig);
      set({ config: parsed, isLoaded: true });
    } catch (error) {
      console.warn('Error loading Firebase Remote Config [date_time_range]:', error);
      set({ config: null, isLoaded: true });
    }
  },
}));
